import onlyDigitsLength from "../onlyDigitsLength";
import { isNotAllSameDigit, isNotSequence } from "../phoneNumberRegex";
var regexAddress = /^[#.\da-zA-Zs, ]+$/;
var regexAddress2 = /^$|^(?![0-9]+$)[#.\da-zA-Zs,$`~!@#+= ]+$/;
var regexNumbers = /^[0-9]*$/;
var regexAlpabets = /^[A-Za-z ]+$/;
var regexIncome = /^[0-9]*$/;
/**
 * Email rule:
 * user: letters, numbers, dashes and periods, with extension between 2 and 30 characters
 * domainName: letters, numbers and periods
 * domainExtension: letters only, with extension between 2 and 10 characters
 */
var regexEmail = /^[a-zA-Z0-9]+([._-]?[a-zA-Z0-9])*@([a-zA-Z0-9]+[.-]?)+[a-zA-Z]{2,10}$/;
var regexEmailLength = /^.{2,30}@/;
export var validateEmail = function (value) {
    return ((regexEmail.test(value) && regexEmailLength.test(value)) ||
        "forms.errors.email.invalid_chars");
};
export var validateCity = function (value) {
    var size = value.length;
    switch (false) {
        case size >= 2 && size <= 18:
            return "forms.errors.city.range_length";
        case regexAlpabets.test(value):
            return "forms.errors.city.invalid_schema";
        default:
            return true;
    }
};
export var validateIncome = function (value) {
    return onlyDigitsLength(value) >= 8
        ? "forms.errors.income.invalid_length"
        : regexIncome.test(value) || "forms.errors.income.invalid_schema";
};
export var validatePhoneStruct = function (value) {
    return onlyDigitsLength(value) < 10 && onlyDigitsLength(value) > 0
        ? "forms.errors.phone.required_length"
        : (isNotAllSameDigit(value) && isNotSequence(value)) ||
            "forms.errors.rules.phone";
};
export var validateZip = function (value) {
    return onlyDigitsLength(value) < 5
        ? "forms.errors.zipCode.char_length"
        : value !== "00000" || "forms.errors.zipCode.invalid_schema";
};
export var validateAddress = function (value) {
    return ((!regexNumbers.test(value) && regexAddress.test(value)) ||
        "forms.errors.addr_line1.invalid_schema");
};
export var validateAddress2 = function (value) {
    return regexAddress2.test(value) || "forms.errors.addr_line2.invalid_schema";
};
